exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-leagues-js": () => import("./../../../src/pages/leagues/[...].js" /* webpackChunkName: "component---src-pages-leagues-js" */),
  "component---src-pages-single-games-js": () => import("./../../../src/pages/single_games/[...].js" /* webpackChunkName: "component---src-pages-single-games-js" */),
  "component---src-pages-tournaments-js": () => import("./../../../src/pages/tournaments/[...].js" /* webpackChunkName: "component---src-pages-tournaments-js" */)
}

